var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContracts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3488 3.44185V12.5581C14.3488 13.9067 13.2555 15 11.9069 15H4.09298C2.74442 15 1.65112 13.9067 1.65112 12.5581V3.44185C1.65112 2.0933 2.74442 1 4.09298 1H11.9069C13.2555 1 14.3488 2.0933 14.3488 3.44185ZM13.372 3.44185C13.372 2.63246 12.7163 1.97674 11.9069 1.97674H4.09298C3.28358 1.97674 2.62786 2.63246 2.62786 3.44185V12.5581C2.62786 13.3675 3.28358 14.0232 4.09298 14.0232H11.9069C12.7163 14.0232 13.372 13.3675 13.372 12.5581V3.44185Z",
    fill: "#8E97A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99979 4.60474C8.26937 4.60474 8.48816 4.82353 8.48816 5.09311C8.48816 5.36269 8.26937 5.58148 7.99979 5.58148H4.74399C4.47441 5.58148 4.25562 5.36269 4.25562 5.09311C4.25562 4.82353 4.47441 4.60474 4.74399 4.60474H7.99979Z",
    fill: "#8E97A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2556 7.20923C11.5252 7.20923 11.744 7.42802 11.744 7.6976C11.744 7.96718 11.5252 8.18597 11.2556 8.18597H4.74399C4.47441 8.18597 4.25562 7.96718 4.25562 7.6976C4.25562 7.42802 4.47441 7.20923 4.74399 7.20923H11.2556Z",
    fill: "#8E97A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 10C11.2693 10 11.4881 10.2188 11.4881 10.4884C11.4881 10.758 11.2693 10.9767 10.9997 10.9767H4.48813C4.21855 10.9767 3.99976 10.758 3.99976 10.4884C3.99976 10.2188 4.21855 10 4.48813 10H10.9997Z",
    fill: "#8E97A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.4b7072bc82eea394ae9ab9ac9de9cbd9.svg";
export { ForwardRef as ReactComponent };